<p-dialog
  header="Confirmation"
  [visible]="visible"
  [style]="{ width: '400px' }"
  [closable]="false"
  (visibleChange)="close()"
  [modal]="true"
>
  <div *ngIf="isLoading" class="flex justify-content-center">
    <i class="fa fa-2x fa-spin fa-spinner"></i>
  </div>

  <div *ngIf="!isLoading" class="py-4">
    Please confirm you wish to grab this Job for
    {{ supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
  </div>

  <p-footer>
    <button
      type="button"
      pButton
      label="Cancel"
      (click)="visibleChange.emit(false)"
      [disabled]="isLoading"
      class="ui-button-secondary"
    ></button>
    <button
      type="button"
      pButton
      label="Grab"
      (click)="acceptJob()"
      [disabled]="isLoading"
    ></button>
  </p-footer>
</p-dialog>

<p-toast [key]="toastKey" [position]="toastPosition" [baseZIndex]="1000"></p-toast>
